import model from 'modules/role/roleModel';

const { fields } = model;

export default [
  fields.id,
  fields.name,
  fields.description,
  fields.company,
  fields.permission,
  fields.createdAt,
  fields.updatedAt
];
